<template>
  <div class="login-wrap">
    <div
      class="content"
      v-show="showLogin"
    >
      <!-- <img src="@/assets/img/zy_logo.png" class="logo" /> -->
      <div class="message">
        <div class="tel-number">手机号码</div>
        <div class="fieldBox">
          <van-field
            v-model="form.phone"
            maxlength="11"
            placeholder="请输入您的手机号码"
            type="digit"
            @input="change"
          />
        </div>
        <span
          class="size"
          v-show="showInfo"
        >请输入正确的手机号码</span>
        <div class="code">验证码</div>
        <div class="fieldBoxs">
          <van-field
            v-model="form.pin"
            class="custom-field-border"
            maxlength="6"
            placeholder="请输入验证码"
            @input="
              replaceInput({
                object: form,
                key: 'pin',
                filter: ['exceptNumber'],
              })
            "
          />
          <span class="send-ident-code">
            <span
              class="unsent"
              v-if="isSentCode"
              @click="sendIdentCode"
            >获取验证码</span>
            <span
              class="sent"
              v-else
            >获取验证码
              <van-count-down
                :time="time"
                format="ss"
                class="count-down"
                @finish="defaultTimeout"
              />
              s</span>
          </span>
        </div>
      </div>

      <div
        :class="isCanLogin ? 'login-button-box' : 'login-button'"
        @click="onSubmitLogin"
      >
        <span>提交</span>
      </div>

      <!-- <div class="protocol-wrap">
        <van-checkbox
          shape="square"
          style="font-size:14px"
          checked-color="#ee0a24"
          v-model="checked"
        >同意</van-checkbox>
        <div
          class="protocol-text"
          @click="protocolClick"
        >中银保险有限公司车险网络平台隐私政策</div>
      </div> -->
    </div>
    <!-- 免责声明 -->
    <van-dialog
      v-model="isShowTips"
      title="免责声明"
      :show-cancel-button="false"
      confirm-button-text="我知道了"
      @confirm="confirmHandle"
    >
      <div class="dialog-wrap">
        <p>
          该服务由中保车服科技服务股份有限公司提供，相关服务和责任由该第三方承担。若有疑问，请咨询我司客服<a
            href="tel:4006995566"
          >（4006995566）</a>或第三方客服<a href="tel:4000026862">（4000026862）</a>。
        </p>
      </div>
    </van-dialog>
    <!-- 授权协议 -->
    <van-popup
      class="confirm-dialog"
      round
      position="bottom"
      v-model="showPopup"
    >
      <div class="confirm-dialog__header">
        <div class="title">获取您的个人信息</div>
      </div>
      <div class="confirm-dialog__body">
        <div class="protocol-tips">
          为了便于您使用中保车服科技服务股份有限公司的服务，中银保险将您的以下信息传递给中保车服科技服务股份有限公司。您通过第三方服务页面主动提供给第三方的个人信息，相关信息保护责任由该第三方承担。
        </div>
        <div class="protocol-wrap">
          <van-checkbox
            :bind-group="false"
            shape="square"
            style="font-size: 14px"
            checked-color="#3399FF"
            v-model="checked"
          />
          <div class="protocol-text-box">
            <span>我已阅读并同意</span>
            <span
              class="protocol-text"
              @click="protocolClick"
            >
              《中银保险有限公司车险网络平台隐私政策》
            </span>
          </div>
        </div>
      </div>
      <div class="confirm-dialog__footer">
        <div
          class="btn confirm"
          @click="confirm"
        >允许</div>
        <div
          class="btn"
          @click="cancel"
        >拒绝</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import {
  getCode,
  codeLogin,
  userCar,
  vasCommonCheckToken,
  loginNoToken,
  insertCar
} from '@/common/api.js';
import { cookieSet, cookieGet } from '@/common/cookie';
// 限制字符输入规则
import { mixins } from '@/mixins/replaceInput';

export default {
  mixins: [mixins],
  data() {
    return {
      form: {
        phone: '',
        pin: ''
      },
      showInfo: false,
      time: 60 * 1000,
      isSentCode: true,
      checked: false,
      showLogin: false,
      isShowTips: false,
      showPopup: false,
      productType: '',
      vinNo: '',
      carNo: '',
      homePage: ''
    };
  },

  computed: {
    // 控制提交按钮的颜色
    isCanLogin() {
      return this.form.phone && this.form.pin;
    }
  },

  watch: {},

  async mounted() {
    this.init();
  },
  activated() {
    this.init();
  },

  methods: {
    init() {
      if (this.$route.query.homePage) {
        this.homePage = this.$route.query.homePage;
      }
      // 从协议返回无动作
      console.log('showPopup', this.showPopup);
      if (!this.showPopup) {
        // 查看是否登录过
        const token = cookieGet('token') || '';
        const phone = cookieGet('phone') || '';
        if (token && phone && !this.$route.query.token) {
          this.checkUserCar();
        } else {
          this.form.phone = phone;
          this.form.pin = '';
          this.isSentCode = true;
          this.checked = false;
        }
        // 免责声明
        this.isShowTips = true;
      }
    },
    confirmHandle() {
      // 授权协议
      this.showPopup = true;
    },
    cancel() {
      this.showPopup = false;
    },
    confirm() {
      if (!this.checked) {
        Toast('请勾选同意中银保险有限公司车险网络平台隐私政策');
        return;
      }
      if (this.$route.query.token) {
        this.noLoginProcess();
      } else {
        this.showPopup = false;
        this.showLogin = true;
      }
    },
    // 免登陆的流程,中银自带参数过来
    async noLoginProcess() {
      if (this.$route.query.productType) {
        this.productType = this.$route.query.productType;
      }
      if (this.$route.query.carNo) {
        this.carNo = this.$route.query.carNo;
      }
      if (this.$route.query.vinNo) {
        this.vinNo = this.$route.query.vinNo;
      }
      if (this.$route.query.vinNo) {
        this.vinNo = this.$route.query.vinNo;
      }

      if (this.$route.query.token) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
        try {
          const res = await loginNoToken({
            channelToken: this.$route.query.token,
            companyNo: 'BOCI' // 中银的写死的
          });
          console.log('res', res);
          const token = res.token;
          const mobile = res.mobile;
          cookieSet('phone', mobile);
          if (
            token &&
            (document.domain.indexOf('vas') > -1 ||
            document.domain.indexOf('zengzhi') > -1 ||
            document.domain.indexOf('localhost') > -1)
          ) {
            cookieSet('token', token);
          }
          this.bindCar();
        } catch (error) {
          console.log(error);
        }
      }
    },
    async bindCar() {
      if (this.$route.query.vinNo) {
        try {
          await insertCar(
            {
              carNo: this.$route.query.carNo ? this.$route.query.carNo : '',
              vinNo: this.$route.query.vinNo
            },
            true
          ).then((res) => {
            this.$toast.clear();
            this.gotoRightList();
          });
        } catch (error) {
          console.log(error);
          this.$toast.clear();
          this.gotoRightList();
        }
      } else {
        this.$toast.clear();
        this.gotoRightList();
      }
    },
    gotoRightList() {
      this.$router.push({
        name: 'interests',
        query: {
          source: 'login',
          serviceType: this.productType, // 外部用的大类来的
          homePage: this.homePage || '',
          carNo: this.$route.query.carNo
        }
      });
    },
    // 获取验证码
    async sendIdentCode() {
      if (this.form.phone && this.form.phone.length < 11) {
        this.showInfo = true;
        return;
      }

      if (this.validateForm()) {
        if (!this.checked) {
          Toast('请勾选同意中银保险有限公司车险网络平台隐私政策');
          return;
        }
        this.phonePinForm();
        this.isSentCode = false;
        Toast('验证码已发送');
      }
    },

    // 验证码倒计时
    defaultTimeout() {
      this.isSentCode = true;
    },

    // 验证码接口
    async phonePinForm() {
      try {
        const res = await getCode({ phone: this.form.phone });
        this.codeDisable = true;
        Toast('获取验证码成功');
        this.countDownSecond = 60;
        this.timer = setInterval(this.countDown, 1000);
        console.log(res);
      } catch (error) {
        console.log(error);
      }
      // try {
      //   await getCode({ phone: this.form.phone }).then((res) => {
      //     this.showInfo = false;
      //     if (res.data.code !== 200) {
      //       this.isSentCode = true;
      //       Toast(res.data.message);
      //       return;
      //     }
      //   });
      // } catch (error) {
      //   this.isSentCode = true;
      //   Toast("后台数据有误");
      // }
    },

    // 判断手机号是否正确
    validateForm() {
      const mobile = /^1[23456789]\d{9}$/;
      let isValidate = false;
      if (!mobile.test(this.form.phone)) {
        this.showInfo = true;
        return isValidate;
      } else {
        this.showInfo = false;
        isValidate = true;
      }

      return isValidate;
    },

    // 提交验证
    async onSubmitLogin() {
      const isValidate = await this.validateForm();
      if (!isValidate) {
        return;
      }
      if (!this.form.pin) {
        Toast('请输入验证码');
        return;
      }
      // if (!this.checked) {
      //   Toast('请勾选同意中银保险有限公司车险网络平台隐私政策');
      //   return;
      // }

      try {
        const res = await codeLogin({
          phone: this.form.phone,
          code: this.form.pin
        });
        if (
          document.domain.indexOf('vas') > -1 ||
          document.domain.indexOf('zengzhi') > -1 ||
          document.domain.indexOf('localhost') > -1
        ) {
          cookieSet('token', res);
          cookieSet('phone', this.form.phone);
          // cookieSet("signKey", JSON.parse(res.data.data).signKey, {
          //   domain: window.location.hostname,
          // });
        }

        localStorage.setItem('_phone', this.form.phone);
        this.checkUserCar();
      } catch (error) {
        console.log(error);
      }

      // await codeLogin({ phone: this.form.phone, code: this.form.pin }).then((res) => {
      //   console.log(res.data);
      //   if (res.data.code == 200) {
      //     if (document.domain.indexOf("vas") > -1) {
      //       cookieSet("token", JSON.parse(res.data.data).token, {
      //         domain: window.location.hostname,
      //       });
      //       cookieSet("signKey", JSON.parse(res.data.data).signKey, {
      //         domain: window.location.hostname,
      //       });
      //     }
      //     localStorage.setItem("_phone", this.form.phone);
      //     this.checkUserCar();
      //   } else {
      //     Toast(res.data.message);
      //   }
      // });
    },

    // 查看用户绑定车辆
    async checkUserCar() {
      try {
        const res = await userCar({});
        // 重置状态
        if (res) {
          this.checked = false;
          this.showLogin = false;
          this.isShowTips = false;
          this.showPopup = false;
          this.form = {
            phone: '',
            pin: ''
          };
        }
        if (res.length > 0) {
          this.$router.push({
            name: 'interests',
            query: {
              source: 'login',
              homePage: this.homePage || ''
            }
          });
        } else {
          this.$router.push({
            name: 'listing',
            query: {
              homePage: this.homePage || ''
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    change() {
      if (this.form.phone && this.form.phone.length === 11) {
        this.showInfo = false;
      }
    },

    // token验证
    async tokenTime() {
      await vasCommonCheckToken({}).then((res) => {
        console.log(res);
        if (res) {
          this.checkUserCar();
        }
      });
    },
    protocolClick() {
      this.$router.push('bociProtocol');
    }
  }
};
</script>

<style lang="scss" scoped>
.login-wrap {
  position: relative;

  display: flex;
  overflow: hidden;

  width: 7.5rem;
  height: 100vh;

  font-family: PingFangSC-Regular;

  .content {
    display: flex;

    width: 100%;
    height: 100%;
    padding: 0 30px;

    .logo {
      position: absolute;
      top: 48px;

      width: 120px;
      height: 34px;
    }

    .message {
      // justify-content: center;
      position: absolute;
      top: 138px;

      display: flex;
      flex-direction: column;

      width: 85%;

      .tel-number {
        color: #646464;

        font-size: 15px;
        font-weight: 400;
      }

      .fieldBox {
        display: flex;

        border-bottom: 1px solid #e6e6e6;
      }

      .size {
        margin-top: 4px;

        letter-spacing: 0.18px;

        color: #ff3c5f;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
      }

      .fieldBoxs {
        position: relative;

        display: flex;
        overflow: hidden;

        text-align: center;

        border-bottom: 1px solid #e6e6e6;

        .custom-field-border {
          width: 80%;
        }

        .send-ident-code {
          position: absolute;
          top: 36%;
          right: 1%;

          font-size: 16px;

          .unsent {
            color: #c0233f;
          }
          .sent {
            color: #eecbd1;
          }
          .count-down {
            display: inline-block;

            color: #eecbd1;
          }
        }
      }

      .code {
        width: 60px;
        height: 20px;
        margin-top: 30px;

        color: #646464;

        font-size: 15px;
        font-weight: 400;
      }
    }

    .login-button {
      position: absolute;
      top: 400px;

      display: flex;
      flex-direction: column;

      width: 85%;

      border-radius: 4px;
      // justify-content: center;
      background: #eecbd1;

      span {
        display: inline-block;
        justify-content: center;

        height: 48px;

        text-align: center;

        color: #ffffff;

        font-size: 18px;
        line-height: 48px;
      }
    }

    .login-button-box {
      position: absolute;
      top: 400px;

      display: flex;
      flex-direction: column;

      width: 85%;

      border-radius: 4px;
      // justify-content: center;
      background: #c0233f;

      span {
        display: inline-block;
        justify-content: center;

        height: 48px;

        text-align: center;

        color: #ffffff;

        font-size: 18px;
        line-height: 48px;
      }
    }

    .protocol-wrap {
      position: absolute;
      top: 448px;

      display: flex;
      flex-direction: row;

      height: 40px;

      .protocol-text {
        height: 40px;

        color: #c0233f;

        font-size: 14px;
        line-height: 40px;
      }
    }
  }
}
.dialog-wrap {
  padding: 16px;

  font-size: 14px;
  line-height: 20px;
}
.confirm-dialog {
  .confirm-dialog__header {
    .title {
      padding: 16px;

      font-size: 18px;
      font-weight: 600;
    }
  }

  .confirm-dialog__body {
    .protocol-tips {
      padding: 0 16px;

      color: #646464;

      font-size: 14px;
      font-weight: 400;
      line-height: 1.2;
    }
    .protocol-wrap {
      display: flex;
      align-items: flex-start;

      padding: 16px;

      .van-checkbox {
        flex: 30px 0 0;
      }

      .protocol-text-box {
        font-size: 14px;
        line-height: 20px;
        .protocol-text {
          color: #3399ff;
        }
      }
    }
  }

  .confirm-dialog__footer {
    padding: 16px;

    box-shadow: 0 -1px 0 0 rgba(230, 230, 230, 1);
    .btn {
      padding: 14px;

      text-align: center;

      color: #3399ff;
      border-radius: 4px;

      font-size: 16px;
      font-weight: 600;

      &.confirm {
        color: #ffffff;
        background: #3399ff;
      }
    }
  }
}
</style>

<style lang="scss">
.login-wrap {
  .van-cell {
    padding-left: 0px;
    // height: 40px;
  }
}
</style>
